import React from 'react';
import { Toast } from 'antd-mobile';

import { appMethod as app } from '@utils/app';

import './RowNumCustomComponent.less';

/**
 * type: 'row-num'
 * 组件：排号组件
 */
export default class RowNumCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    this.isOpenRowNumber(compindex, pageInstance);
  }

  isOpenRowNumber = (compindex, pageInstance) => {
    let newData = {};
    app.sendRequest({
      url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
      data: {
        sub_app_id: app.getPageFranchiseeId()
      },
      success: (res) => {
        newData['eles[' + compindex + '].numberTypeData'] = res.data;
        pageInstance.setData(newData);
        Toast.hide();
        this.rowNumber(pageInstance, compindex);
      }
    });
  }

  rowNumber = (pageInstance, compindex) => {
    let newData = {};
    app.sendRequest({
      url: '/index.php?r=AppTostore/getLiningUpQueueByUserToken',
      data: {
        sub_app_id: app.getPageFranchiseeId()
      },
      method: 'post',
      success: function (res) {
        newData['eles[' + compindex + '].currentRowNumberData'] = res.data;
        pageInstance.setData(newData);
      }
    })
  }

  rowNumberRefresh = (e) => {
    const pageInstance = app.getAppCurrentPage();
    const compindex = e.currentTarget.dataset.compindex;
    Toast.loading('加载中', 0);
    this.isOpenRowNumber(compindex, pageInstance);
  }

  showCancelWindow = (e) => {
    const pageInstance = app.getAppCurrentPage();
    const compindex = e.currentTarget.dataset.compindex;
    let newData = {};
    newData['eles[' + compindex + '].isShowCancelWindow'] = true;
    pageInstance.setData(newData);
  }

  goToCheckRowNumberDetail = (e) => {
    const orderId = e.currentTarget.dataset.orderId;
    const franchiseeId =  app.getPageFranchiseeId();
    app.turnToPage('/orderMeal/pages/checkRowNumberDetail/checkRowNumberDetail?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : ''));
  }

  showTakeNumberWindow = (e) => {
    const pageInstance = app.getAppCurrentPage();
    const compindex = e.currentTarget.dataset.compindex;
    const newData = {};
    newData['eles[' + compindex + '].selectRowNumberTypeId'] = '';
    newData['eles[' + compindex + '].isShowTakeNumberWindow'] = true;
    pageInstance.setData(newData)
  }

  selectRowNumberType = (e) => {
    const pageInstance = app.getAppCurrentPage();
    const compindex = e.currentTarget.dataset.compindex;
    let newData = {};
    newData['eles[' + compindex + '].selectRowNumberTypeId'] = e.currentTarget.dataset.id;
    pageInstance.setData(newData);    
  }

  hideTakeNumberWindow = (e) => {
    const pageInstance = app.getAppCurrentPage();
    const compindex = e.currentTarget.dataset.compindex;
    let newData = {};
    newData['eles[' + compindex + '].isShowTakeNumberWindow'] = false;
    pageInstance.setData(newData);
  }

  goToPreviewRowNumberOrder = (e) => {
    const pageInstance = app.getAppCurrentPage();
    const compindex = e.currentTarget.dataset.compindex;
    const id = pageInstance.data.eles[compindex].selectRowNumberTypeId;
    const franchiseeId =  app.getPageFranchiseeId();
    let newData = {};
    if (!id) {
      app.showToast({
        title: '请选择排号类型',
        icon: 'none'
      })
      return;
    }
    newData['eles[' + compindex + '].isShowTakeNumberWindow'] = false;
    pageInstance.setData(newData);
    app.turnToPage('/orderMeal/pages/previewRowNumberOrder/previewRowNumberOrder?detail=' + id + (franchiseeId ? '&franchisee=' + franchiseeId : ''));
  }

  sureTakeNumber = (e) => {
    const pageInstance = app.getAppCurrentPage();
    const compindex = e.currentTarget.dataset.compindex;
    let newData = {};
    let compData = pageInstance.data.eles[compindex];
    let id = compData.selectRowNumberTypeId;
    if(!id){
      app.showToast({
        title: '请选择排号类型',
        icon: 'none'
      })
      return;
    }
    if (compData.isClick){return}
    newData['eles[' + compindex + '].isClick'] = true;
    pageInstance.setData(newData);
    app.sendRequest({
      url: '/index.php?r=AppTostore/addLineUpOrder',
      data: {
        line_up_type_id: id,
        formId: e.detail.formId,
        total_price: 0,
        sub_app_id: app.getPageFranchiseeId()
      },
      method: 'post',
      success: (res) => {
        app.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: res.data,
            total_price: 0
          },
          success: (res) => {
            newData = {};
            newData['eles[' + compindex + '].isClick'] = false;
            newData['eles[' + compindex + '].isShowTakeNumberWindow'] = false;
            pageInstance.setData(newData);
            this.isOpenRowNumber(compindex, pageInstance);
            app.showToast({
              title: '取号成功，请耐心等待',
              icon: 'none'
            })
          }
        });
      }
    });
  }

  cancelCheckRowNumber = (e) => {
    let orderId = e.currentTarget.dataset.orderId;
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newData = {};
    app.sendRequest({
      url: '/index.php?r=AppTostore/lineUpOrderRefund',
      method: 'post',
      data: {
        order_id: orderId,
        sub_app_id: app.getPageFranchiseeId()
      },
      success: (res) => {
        this.isOpenRowNumber(compindex, pageInstance);
        newData['eles[' + compindex + '].isShowCancelWindow'] = false;
        pageInstance.setData(newData);
      }
    });
  }

  hideCancelWindow = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newData = {};
    newData['eles[' + compindex + '].isShowCancelWindow'] = false;
    pageInstance.setData(newData);
  }

  render() {
    const data = this.props.data;
    let {
      customFeature, currentRowNumberData, numberTypeData,
      isShowTakeNumberWindow, isShowCancelWindow, selectRowNumberTypeId
    } = data;
    const { lineBackgroundColor, picBorderRadius, secColor } = customFeature;

    /**
     * @desc 数据初始化
     */
    currentRowNumberData = currentRowNumberData || { count_info: [] };
    numberTypeData = numberTypeData || { additional_info: {} };
    isShowTakeNumberWindow = !!isShowTakeNumberWindow;
    isShowCancelWindow = !!isShowCancelWindow;
    
    /**
     * @desc 头部内容
     */
    const topWrap = () => (
      <div className="row-number-top" style={{ backgroundColor: (currentRowNumberData.id || numberTypeData.status == 1) ? lineBackgroundColor : '#838383' }}>
        {!currentRowNumberData.id && <div className="number-top-title">尚未取号</div>}
        {currentRowNumberData.id &&
          <div>
            <div className="number-top-title">{currentRowNumberData.line_up_type_data.name}{currentRowNumberData.queue_num_name}</div>
            <div className="wait-content">
              <span>
                <span className="color-round" style={{ backgroundColor: secColor }}></span>
                {currentRowNumberData.status == 4 ? '已过号' : `还要等待: ${currentRowNumberData.head_wait_num}个号`}
              </span>
              <span>
                <span className="color-round" style={{ backgroundColor: secColor }}></span>
                预计等待: {currentRowNumberData.status == 4
                  ? '--'
                  : (currentRowNumberData.prepare_wait_time > numberTypeData.max_display_time ? '>' + numberTypeData.max_display_time : currentRowNumberData.prepare_wait_time) + '分钟'}
              </span>
            </div>
          </div>
        }
      </div>
    );

    /**
     * @desc 底部内容
     */
    const bottomWrap = () => (
      <div className="row-number-bottom">
        <div className="number-bottom-content">
          <div className="number-refresh" onClick={(e) => this.rowNumberRefresh(e)} style={{ backgroundColor: secColor }}>
            <span className="ico-moon icon-row-number-refresh"></span>
          </div>
          <div className="bottom-content-title">
            <div>类型</div>
            <div>前方排队</div>
            <div>{!currentRowNumberData.id ? '预计时间' : '当前进度'}</div>
          </div>
          {currentRowNumberData.count_info.map((item, index) => (
            <div key={index}>
              <div className="content-type">
                <span>{item.line_up_type_name}</span>
                {item.accept_range.enable == 1 && <span>{item.accept_range.from}-{item.accept_range.to}人</span>}
              </div>
              <div>{item.head_wait_num}</div>
              {(currentRowNumberData.id || numberTypeData.status != 0) &&
                <div className="estimated-time">
                  {!currentRowNumberData.id
                    ? (item.prepare_wait_time > 0 ? (item.prepare_wait_time > numberTypeData.max_display_time ? '>' + numberTypeData.max_display_time : item.prepare_wait_time) + '分钟' : '无需等待')
                    : (item.earliest_queue_num_name || '--')}
                  {item.prepare_wait_time <= 0 && !currentRowNumberData.id && <div className="row-number-round" style={{ backgroundColor: lineBackgroundColor }}></div>}
                </div>
              }
              {!(currentRowNumberData.id) && numberTypeData.status == 0 && <div>- -</div>}
            </div>
            ))}
        </div>
        {!numberTypeData.status && <div className="no-open-row-number">商家暂未开启取号功能</div>}
        <div className="number-bottom-bottom">
          <div className="number-tips">{numberTypeData.additional_info.info}</div>
          {currentRowNumberData.id
            ? <div className="take-number-box">
                <span
                  style={{ color: lineBackgroundColor, borderColor: lineBackgroundColor, borderRadius: picBorderRadius }}
                  data-compindex={this.props.index}
                  onClick={this.showCancelWindow}>取消排号</span>
                <span
                  style={{ backgroundColor: lineBackgroundColor, borderRadius: picBorderRadius }}
                  data-order-id={currentRowNumberData.order_id}
                  onClick={this.goToCheckRowNumberDetail}>查看号单</span>
              </div>
            : <div className="take-number"
                   style={{ backgroundColor: numberTypeData.status == 1 ? lineBackgroundColor: '#838383', borderRadius: picBorderRadius }}
                   data-compindex={this.props.index}
                   onClick={numberTypeData.status == 1 ? this.showTakeNumberWindow : null}>
                {numberTypeData.status == 1 ? '取号' + (numberTypeData.line_up_price > 0 ? ' ¥' + numberTypeData.line_up_price : '') : '暂停取号'}
              </div>
          }
        </div>
      </div>
    );

    /**
     * @desc 取号弹窗
     */
    const takeNumberWindow = () => (
      <div className="take-number-contain">
        <div className="take-number-head" style={{ backgroundColor: lineBackgroundColor }}>
          <span className="color-round" style={{ backgroundColor: secColor }}></span>
          请选择排号类型
          <span className="color-round" style={{ backgroundColor: secColor }}></span>
        </div>
        <div className="take-number-content">
          {numberTypeData.line_up_type_info.map((item) => (
            <div key={item.id}
                 className={`take-number-type ${ selectRowNumberTypeId == item.id ? 'active' : '' }`}
                 style={{ background: selectRowNumberTypeId == item.id ? lineBackgroundColor : '' }}
                 data-id={item.id}
                 data-compindex={this.props.index}
                 onClick={this.selectRowNumberType}>
                <span>{item.name}</span>
                {item.accept_range.enable == 1 && <span>({item.accept_range.from}-{item.accept_range.to}人)</span>}
            </div>
          ))}
        </div>
        <div className="take-number-bottom">
          <div
            data-compindex={this.props.index}
            onClick={this.hideTakeNumberWindow}>取消</div>
          <form>
            <button type="button"
                    style={{ color: lineBackgroundColor }}
                    data-compindex={this.props.index}
                    onClick={numberTypeData.line_up_price > 0 ? this.goToPreviewRowNumberOrder : this.sureTakeNumber}>
              确认{numberTypeData.line_up_price > 0 ? '¥' + numberTypeData.line_up_price : ''}
            </button>
          </form> 
        </div>
      </div>
    );

    /**
     * @desc 取消取号弹窗
     */
    const cancelNumberWindow = () => (
      <div className="cancel-window-box">
        <div className="cancel-window-content">取消后您的排号信息无法恢复排号费将退款。确定取消？</div>
        <div className="cancel-window-btn">
          <span
            data-order-id={currentRowNumberData.order_id}
            data-compindex={this.props.index}
            onClick={this.cancelCheckRowNumber}>取消排号</span>
          <span
            style={{ color: lineBackgroundColor }}
            data-compindex={this.props.index}
            onClick={this.hideCancelWindow}>继续排号</span>
        </div>
      </div>
    );

    return (
      <div className="custom-component row-num">
        <div id="row-number">
          {topWrap()}
          {bottomWrap()}
        </div>
        {isShowTakeNumberWindow && <div className="take-number-window">{takeNumberWindow()}</div>}
        {isShowCancelWindow && <div className="take-num-cancel-window">{cancelNumberWindow()}</div>}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/row-num-custom-component/RowNumCustomComponent.jsx